export { eq as default } from "@ember/helper";
